//This component will show  saved filter from database
import React from "react";
import reqwest from "reqwest";
import axios from "axios";
import {
  Slider,
  Row,
  Col,
  Card,
  Select,
  Button,
  Modal,
  List,
  Input,
  Popconfirm,
  Progress,
  Alert,
} from "antd";
import { connect } from "react-redux";
import {
  activateDatadic,
  activateFiname,
  activateRecord,
  activateScreen,
  activateStocks,
  activateLoadid,
  activateChange,
} from "../redux";
import {
  CloseCircleTwoTone,
  PoweroffOutlined,
  QuestionCircleOutlined,
  ExclamationCircleOutlined,
  FolderOpenOutlined ,
  RedoOutlined,
  SaveOutlined 

} from "@ant-design/icons";
import SaveFilterO from "./SaveFilterOnly";
const data = [];

const { Option } = Select;
const { confirm } = Modal;
class LoadFilterclass extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      value: "",
      data: [],
      isModalVisible: false,
      setIsModalVisible: false,
      showsaveRest:false,
      loading: false,
      savefill: false,
      runscreen: false,
      count: 10,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handlesave = this.handlesave.bind(this);
    this.handlload = this.handlload.bind(this);
    this.handledel = this.handledel.bind(this);
    this.HandleReq = this.HandleReq.bind(this);
    this.showConfirmNewScreen = this.showConfirmNewScreen.bind(this);
    this.hidecancel = this.hidecancel.bind(this);

    
  }
  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  componentDidMount() {
    this.setState({
      loading: true,
    });
    reqwest({
      url:
        this.props.apppath +
        "/include/api/screener/Simsaveload.cfm?uid=" +
        this.props.auid,
      method: "get",
      type: "json",
    }).then((data) => {
      this.setState({
        data: data.results,
        loading: false,
      });
    });
  }



  fetch = (params = {}) => {
    this.setState({ loading: true });
    reqwest({
      url: "https://siproupdateonly.s3-accelerate.amazonaws.com/stockScreenerInit.json",
      method: "get",
      type: "json",
   
    }).then((data) => {
      this.props.activateStocks(data.screenRating);

      this.props.activateRecord(data.screenRating.length);
      this.props.activateFiname('');
      this.setState({
        loading: false,
      
      });
    });
  };



  
  fetchwithname = (params = {}) => {
    this.setState({ loading: true });
    reqwest({
      url: "https://siproupdateonly.s3-accelerate.amazonaws.com/stockScreenerInit.json",
      method: "get",
      type: "json",
   
    }).then((data) => {
      this.props.activateStocks(data.screenRating);

      this.props.activateRecord(data.screenRating.length);
      
      this.setState({
        loading: false,
      
      });
    });
  };



  handle() {
    this.setState({
      loading: true,
    });
    reqwest({
      url:
        this.props.apppath +
        "/include/api/screener/Simsaveload.cfm?uid=" +
        this.props.auid,
      method: "get",
      type: "json",
    }).then((data) => {
      this.setState({
        data: data.results,
        loading: false,
        savefill: false,
      });
    });
  }
  handlload(id,rid) {
    this.setState({
      loading: true,
    }, () => {
        this.fetchwithname();
  });
  
    this.props.activateDatadic({
      FilterDic: JSON.parse(this.state.data[id].FILTER_),
    });
    this.props.activateFiname(this.state.data[id].NAME_);
    
    this.props.activateLoadid(rid);
    
    this.setState({
      loading: false,
      isModalVisible: false,
    });
   
  }

  handledel(id) {
    this.setState({
      loading: true,
    });
    const del = { filterid: id, userId: this.props.auid };
    axios
      .post(this.props.apppath + "/include/api/screener/Simdel.cfm", del)
      .then((response) => this.handle());
  }
  handlesave() {
    this.setState({
      loading: true,
      savefill: true,
    });

    const article = {
      filter: this.props.datadic.FilterDic,
      filterName: this.props.finame,
      userId: this.props.auid,
      screenerFilterId:this.props.loadid,
    };
    axios
      .post(this.props.apppath + "/include/api/screener/SimsaveEdit.cfm", article)
      .then((response) => this.handle());
  }



  handlesaveLoad() {
    this.setState({
      loading: true,
      savefill: true,
    });

    const article = {
      filter: this.props.datadic.FilterDic,
      filterName: this.props.finame,
      userId: this.props.auid,
      screenerFilterId:this.props.loadid,
    };
    axios
      .post(this.props.apppath + "/include/api/screener/SimsaveEdit.cfm", article)
      .then((response) => this.showModal());
  }



  handlesaveReset() {
    this.setState({
      loading: true,
      savefill: true,
    });

    const article = {
      filter: this.props.datadic.FilterDic,
      filterName: this.props.finame,
      userId: this.props.auid,
      screenerFilterId:this.props.loadid,
    };
    axios
      .post(this.props.apppath + "/include/api/screener/SimsaveEdit.cfm", article)
      .then((response) =>   window.location.reload(false));
  }


  HandleReq(id,rid) {
    this.setState({
      lookingTickers: true,
      runscreen: true,
    });
    this.props.activateScreen(true);
    this.setState({
      count: 40,
    });
    this.props.activateDatadic({
      FilterDic: JSON.parse(this.state.data[id].FILTER_),
    });
    this.props.activateFiname(this.state.data[id].NAME_);
    
    this.props.activateLoadid(rid);
    /*    this.props.activateDatadic({
      FilterDic: JSON.parse(this.state.data[id].FILTER_),
    });
    this.props.activateFiname(this.state.data[id].NAME_); */

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        tables: [JSON.parse(this.state.data[id].FILTER_)],
      }),
    };
    fetch(
      this.props.apppath + "/include/api/screener/ssfilter.cfm",
      requestOptions
    )
      .then((response) => response.json())
      .then((data /*  this.props.activateStocks(data.filteredData ) */) =>
        this.setState(
          {
            my: data.filteredData,
            lookingTickers: false,
            runscreen: false,
            count: 60,
          },
          () => {
            this.props.activateRecord(data.filteredData.length);
            this.props.activateScreen(false);
            this.setState({ count: 100 });
            this.props.activateStocks(data.filteredData);
            this.props.activateChange('');
          }
        )
      )
      .then((data) => 1)
      .catch((error) => {
        this.setState(
          {
            lookingTickers: false,
          },
          () => {
            this.props.activateRecord("No Results");
            this.props.activateScreen(false);
          }
        );
      });
  }

  showPopconfirm = () => {
    this.setState({
      visible: true,
    });
  };


  FilterMount() {
    this.setState({ loading: true });
    reqwest({
      url:
        this.props.apppath + "/include/api/screener/stockScreenerFilter.json",
      //url:'jlast.json',
      method: "get",
      type: "json",
    }).then((data) => {
      this.props.activateDatadic({ FilterDic: data.tables[0] });
      
      this.setState({
        data: data.tables[0].columns,
      });
    });
  }

  showConfirm() {
    confirm({
      title: 'Would you like to overwrite the screen you are editing?',
      icon: <ExclamationCircleOutlined />,
      content: 'This will overwrite existing screen with new filters',
      okText: 'Yes',
      cancelText: 'No',
      onOk:() => {
     this.handlesave()
      },
      onCancel:() => {
        this.props.activateLoadid('');
        this.props.activateChange('');
        this.setState({
          showsavefilteronly: true,
        
        });
        
      },
    });
  }


  showConfirmReset() {
    confirm({
      title: 'Would you like to overwrite the screen you are editing?',
      icon: <ExclamationCircleOutlined />,
      content: 'This will overwrite existing screen with new filters',
      okText: 'Yes',
      cancelText: 'No',
      onOk:() => {
     this.handlesaveReset()
      },
      onCancel:() => {
        this.props.activateLoadid('');
        this.props.activateChange('');
        this.setState({
          showsaveRest: true,
        
        });
        
      },
    });
  }



  handleCanceleditShowfilter(){
    this.FilterMount();
    this.fetch();
    this.handle();
      this.setState({
        setIsModalVisible: true,
        isModalVisible: true,
      });
  }


  showsavereset(){
    this.setState({
      showsaveRest: true,
    
    });
  }
  showConfirmNewScreen(){
    this.setState({
      showsaveFornewScreen: true,
    
    });
  }


  hidecancel = () => {
   
    this.setState({
      showsavefilteronly: false,
      showsaveFornewScreen: false,
    });
  };

  render() {
    const handleOk = () => {
      this.setState({
        setIsModalVisible: false,
        isModalVisible: false,
      });
    };

    const handleCancel = () => {
      this.setState({
        setIsModalVisible: false,
        isModalVisible: false,
      });
    };

    const showModal = () => {
      this.handle();
      this.setState({
        setIsModalVisible: true,
        isModalVisible: true,
      });
    };

    const showReset = () => {
      this.setState({
        loading: true,
      });
      window.location.reload(false);
    };
    const afterSave = () => {
      this.setState({
        showsavefilteronly: false,
        showsaveFornewScreen:false,
        
      }, () => {
        this.FilterMount();
        this.fetch();
        showModal();
        this.props.activateChange('');
    });
    };

    const afterSaveNO = () => {
      this.setState({
        showsavefilteronly: false,
        showsaveFornewScreen:false,
        
      }, () => {
       
    });
    };

    const afterSaveRest = () => {
      this.setState({
        showsavefilteronly: false,
        showsaveFornewScreen:false,
        showsaveRest:false,
      }, () => {
        
        window.location.reload(false);
    });
    };

    const endSafeRest = () => {
      this.setState({
        showsavefilteronly: false,
        showsaveFornewScreen:false,
      }, () => {
        window.location.reload(false);
        
    });
    };
    const endSafe = () => {
      this.setState({
        showsavefilteronly: false,
        showsaveFornewScreen:false,
      }, () => {
        this.FilterMount();
        this.fetch();
        showModal();
        this.props.activateChange('');
    });
    };


    const endSafenow = () => {
      this.setState({
        showsavefilteronly: false,
        showsaveFornewScreen:false,
      }, () => {
      
    });
    };


    const resultss = {
      display: "inline-block",
    };
    let dsihide = "";
    let dsihide2 = "";

    if (this.props.screen == false) {
      dsihide = {
        display: "none",
      };
      dsihide2 = {
        display: "",
      };
    } else {
      dsihide = {
        display: "",
      };
      dsihide2 = {
        display: "none",
      };
    }

    const Restbutton = {
      
 
    };
    return (
      <div style={resultss}>
 
  
       <SaveFilterO  fs={1}  isModalsave={ this.state.showsavefilteronly} aftersave={afterSave} justclose={endSafe} hidecancel={this.hidecancel}></SaveFilterO>
       <SaveFilterO  fs={1}  isModalsave={this.state.showsaveFornewScreen} aftersave={afterSaveNO} justclosenow={endSafenow} hidecancel={this.hidecancel}></SaveFilterO>
       <SaveFilterO   fs={1} isModalsave={this.state.showsaveRest} aftersave={afterSaveRest} justclose={endSafeRest} hidecancel={this.hidecancel}></SaveFilterO>
       {this.props.filtermt != 0   &&  this.props.change==1?
                  <span>
                {this.props.finame != '' ?   ////// edit screen 
                <Popconfirm
                      title="Would you like to save your changes?"
                      okText="Yes"
                      cancelText="No"
                      onConfirm={() => this.showConfirm()}
                      onCancel={() =>this.handleCanceleditShowfilter()}
                      icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                    >
                  <Button  style={{display:'none'}} 
                  icon={<FolderOpenOutlined   />}
                  type="primary"  >
                    Open Screen
                  </Button>{" "}
                  </Popconfirm>
                  :
                  ////// new  screen
                  <Popconfirm
                      title="Would you like to save your screen?"
                      okText="Yes"
                      cancelText="No"
                      onConfirm={() => this.showConfirmNewScreen()}
                      onCancel={() =>this.handleCanceleditShowfilter()}
                      icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                    >
                  <Button style={{display:'none'}}  icon={<FolderOpenOutlined   />}  type="primary"   >
                    Open Screen 
                  </Button>{" "}
                  </Popconfirm>

                  
                  }
        </span>:  <span> <Button   style={{display:'none'}}  icon={<FolderOpenOutlined  />} type="primary" onClick={() => showModal()} >
                    Open Screen
                  </Button> {" "} </span> }


        { (this.props.filtermt != 0 || this.props.filtermt != "") &&     this.props.change==1 ? (
          
          <span>
          {this.props.finame != '' ?   ////// edit screen showReset
          <Popconfirm
            title="Would you like to save your screen?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => this.showsavereset()}
            onCancel={() =>afterSaveRest()}
            icon={<QuestionCircleOutlined style={{ color: "red" }}  />}
          >
            <Button    style={Restbutton} size={'large'}  icon={<RedoOutlined   />} type="primary" loading={this.state.loading}>
              Reset
            </Button>
          </Popconfirm>
         :
         
         <Popconfirm
         title="Would you like to save your changes?"
         okText="Yes"
         cancelText="No"
         onConfirm={() => this.showsavereset()}
         onCancel={() =>afterSaveRest()}
         icon={<QuestionCircleOutlined style={{ color: "red" }} />}
       >
         <Button   size={'large'}  style={Restbutton}   icon={<RedoOutlined   />} type="primary" loading={this.state.loading}>
           Reset
         </Button>
       </Popconfirm>  }
         </span>

        ) 
        
        
        : 
        
        (
          <Button  style={Restbutton}  size={'large'}    icon={<RedoOutlined   />}
            onClick={showReset}
            type="primary"
            loading={this.state.loading}
          >
            Reset
          </Button>
        )
        
        }

{" "}
{  

this.props.filtermt != 0 || this.props.filtermt != "" ? 
<Button 
 size={'large'}
icon={<SaveOutlined    />}
            onClick={this.showConfirmNewScreen}
            type="primary"
            loading={this.state.loading}
          >
            Save 
          </Button> 
:<Button 
disabled
icon={<SaveOutlined    />}
            onClick={this.showConfirmNewScreen}
            size={'large'}
            type="primary"
            loading={this.state.loading}
          >
            Save 
          </Button> 

}

        <Modal
          title="Open Screen"
          visible={this.state.isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          {this.state.data != "" ? (
            <div>
              {" "}
              <div style={dsihide}>
                Running Screen........
                <Progress
                  size="small"
                  strokeColor={{
                    "0%": "#108ee9",
                    "100%": "#87d068",
                  }}
                  percent={this.state.count}
                  status="active"
                  showInfo={false}
                  strokeLinecap="square"
                />
              </div>
              <div style={dsihide2}>
                {" "}
                <List
                  itemLayout="horizontal"
                  dataSource={this.state.data}
                  loading={this.state.loading}
                  renderItem={(item) => (
                    <List.Item>
                      <List.Item.Meta title={item.NAME_} description="" />
                      <List.Item
                        actions={[
                          <Button
                            key={item.cid}
                            id={item.cid}
                            onClick={() => this.HandleReq(item.cid,item.id)}
                            loading={this.props.screen}
                          >
                            Run Screen
                          </Button>,
                          <Button
                            key={item.cid}
                            id={item.cid}
                            onClick={() => this.handlload(item.cid,item.id)}
                          >
                            Edit Filter
                          </Button>,
                          <Popconfirm
                            title="Are you sure to delete this Screen?"
                            okText="Yes"
                            cancelText="No"
                            id={item.id}
                            onConfirm={() => this.handledel(item.id)}
                            icon={
                              <QuestionCircleOutlined
                                style={{ color: "red" }}
                              />
                            }
                          >
                            <Button
                              danger
                              id={item.id}
                              onClick={this.showPopconfirm}
                              key={item.id}
                            >
                              Delete
                            </Button>
                          </Popconfirm>,
                        ]}
                      >
                        {" "}
                      </List.Item>
                    </List.Item>
                  )}
                />{" "}
              </div>
            </div>
          ) : (
            "It looks like you don’t have any saved screens. Click OK and select Create Screen to start building a screen."
          )}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  datadic: state.datadic,
  apppath: state.apppath,
  stocks: state.stocks,
  record: state.record,
  auid: state.auid,
  finame: state.finame,
  screen: state.screen,
  loadid: state.loadid,
  change: state.change,
});

const mapDispatchToProps = {
  activateDatadic,
  activateFiname,
  activateRecord,
  activateScreen,
  activateStocks,
  activateLoadid,
  activateChange 
};

const LoadFilter = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadFilterclass);

export default LoadFilter;
